<script>
export default {
  tags: [
    { id: 1, tagName: 'アップテンポ' },
    { id: 2, tagName: 'バラード' },
    { id: 3, tagName: '明るい' },
    { id: 4, tagName: 'キュート' },
    { id: 5, tagName: 'さわやか' },
    { id: 6, tagName: '和' },
    { id: 7, tagName: 'エレガント' },
    { id: 8, tagName: 'モダン' },
    { id: 9, tagName: 'ナチュラル' },
    { id: 10, tagName: 'クラシック' },
    { id: 11, tagName: 'ジャズ' },
    { id: 12, tagName: 'ボーカル' },
    { id: 13, tagName: 'インスト' },
    { id: 14, tagName: '英詞' }
  ],
  findAll () {
    return this.tags
  },
  findTagNameByTagId (tagId) {
    let index = tagId - 1
    if (index < 0 || index > 14) {
      return ''
    } else {
      return this.tags[index].tagName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/TagService.vue